// The share card: the porch with "Happy Halloween" big across the top, the message under it, and who it is from at the
// bottom. Laid out at 1200x630 and scaled to whatever size it is drawn at. The share box draws it as a preview; the
// render worker draws the real one on the server from the stored message and name (pumpkin#78).

export const CARD_FONTS = ['100px Creepster', '58px "Mystery Quest"', '500 42px Grandstander'];

export function drawCard(g: CanvasRenderingContext2D, base: CanvasImageSource, W: number, H: number, msg: string, name: string, body = 'Grandstander, sans-serif') {
  g.drawImage(base, 0, 0, W, H);
  g.save();
  g.scale(W / 1200, H / 630);
  const w = 1200, h = 630;
  const top = g.createLinearGradient(0, 0, 0, h * 0.55);
  top.addColorStop(0, 'rgba(4, 2, 8, 0.82)'); top.addColorStop(1, 'rgba(4, 2, 8, 0)');
  g.fillStyle = top; g.fillRect(0, 0, w, h * 0.55);
  const bot = g.createLinearGradient(0, h * 0.78, 0, h);
  bot.addColorStop(0, 'rgba(4, 2, 8, 0)'); bot.addColorStop(1, 'rgba(4, 2, 8, 0.85)');
  g.fillStyle = bot; g.fillRect(0, h * 0.78, w, h * 0.22);
  g.textAlign = 'center'; g.textBaseline = 'alphabetic'; g.lineJoin = 'round';
  const word = (t: string, x: number, y: number, size: number, fill: string, edge: string, face = 'Creepster') => {
    g.font = `${size}px "${face}", "Arial Black", sans-serif`;
    g.lineWidth = Math.max(4, size * 0.09); g.strokeStyle = edge; g.strokeText(t, x, y);
    g.fillStyle = fill; g.fillText(t, x, y);
  };
  g.shadowColor = 'rgba(255, 120, 20, 0.55)'; g.shadowBlur = 28 * W / 1200;
  word('Happy Halloween', w / 2, 150, 150, '#ff8c1e', '#2a0e00');
  g.shadowBlur = 0;
  if (msg) {
    g.font = `500 42px ${body}`;
    const words = msg.split(/\s+/), lines: string[] = [];
    let cur = '';
    for (const x of words) { const t = cur ? cur + ' ' + x : x; if (g.measureText(t).width > 1020 && cur) { lines.push(cur); cur = x; } else cur = t; }
    lines.push(cur);
    lines.slice(0, 2).forEach((l, i) => {
      const t = i === 1 && lines.length > 2 ? l.replace(/\s*\S*$/, '') + '…' : l;
      g.lineWidth = 6; g.strokeStyle = 'rgba(4, 2, 8, 0.9)'; g.strokeText(t, w / 2, 214 + i * 52);
      g.fillStyle = '#f6ead2'; g.fillText(t, w / 2, 214 + i * 52);
    });
  }
  // Creepster is all capitals: the name keeps its case in the subheading face
  if (name) word(`from ${name}`, w / 2, h - 34, 58, '#ffd36a', '#2a0e00', 'Mystery Quest');
  g.restore();
}
